(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const searchToggle = document.querySelector('[data-search-toggle]');
    const searchPanel = document.querySelector('[data-search-panel]');

    if (searchToggle && searchPanel) {
      const searchInput = searchPanel.querySelector('input[type="search"]');
      const closeButton = searchPanel.querySelector('[data-search-close]');
      let closeTransitionHandler = null;
      let closeTimeoutId = null;

      const focusInput = () => {
        if (!searchInput) return;
        window.setTimeout(() => {
          if (searchPanel.classList.contains('is-active')) {
            searchInput.focus({ preventScroll: true });
          }
        }, 150);
      };

      const clearPendingClose = () => {
        if (closeTransitionHandler) {
          searchPanel.removeEventListener('transitionend', closeTransitionHandler);
          closeTransitionHandler = null;
        }
        if (closeTimeoutId) {
          window.clearTimeout(closeTimeoutId);
          closeTimeoutId = null;
        }
      };

      const openPanel = () => {
        clearPendingClose();
        if (!searchPanel.hidden && searchPanel.classList.contains('is-active')) {
          return;
        }
        searchPanel.hidden = false;
        searchPanel.setAttribute('aria-hidden', 'false');
        requestAnimationFrame(() => {
          searchPanel.classList.add('is-active');
        });
        searchToggle.setAttribute('aria-expanded', 'true');
        focusInput();
      };

      const finalizeClose = () => {
        searchPanel.hidden = true;
        clearPendingClose();
      };

      const closePanel = () => {
        clearPendingClose();
        if (searchPanel.hidden || !searchPanel.classList.contains('is-active')) {
          return;
        }
        searchPanel.classList.remove('is-active');
        searchPanel.setAttribute('aria-hidden', 'true');
        searchToggle.setAttribute('aria-expanded', 'false');

        closeTransitionHandler = () => {
          finalizeClose();
        };

        searchPanel.addEventListener('transitionend', closeTransitionHandler);
        closeTimeoutId = window.setTimeout(finalizeClose, 400);
      };

      searchToggle.addEventListener('click', () => {
        if (searchPanel.classList.contains('is-active')) {
          closePanel();
        } else {
          openPanel();
        }
      });

      if (closeButton) {
        closeButton.addEventListener('click', () => {
          closePanel();
          searchToggle.focus();
        });
      }

      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && searchPanel.classList.contains('is-active')) {
          closePanel();
          searchToggle.focus();
        }
      });

      document.addEventListener('click', (event) => {
        if (!searchPanel.classList.contains('is-active')) {
          return;
        }

        const target = event.target;
        if (searchPanel.contains(target) || searchToggle.contains(target)) {
          return;
        }

        closePanel();
      });
    }
  });

  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.section = this.closest('.section-header') || this;
      this.header = this.section;
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = this.header.getBoundingClientRect();

      this.setHeaderHeight();

      this.setHeaderHeightHandler = this.setHeaderHeight.bind(this);
      this.mediaQueryList = window.matchMedia('(max-width: 990px)');
      if (typeof this.mediaQueryList.addEventListener === 'function') {
        this.mediaQueryList.addEventListener('change', this.setHeaderHeightHandler);
      } else if (typeof this.mediaQueryList.addListener === 'function') {
        this.mediaQueryList.addListener(this.setHeaderHeightHandler);
        this.legacyMediaQueryListener = true;
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.isScrolling = null;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.mediaQueryList) {
        if (this.legacyMediaQueryListener && typeof this.mediaQueryList.removeListener === 'function') {
          this.mediaQueryList.removeListener(this.setHeaderHeightHandler);
        } else if (typeof this.mediaQueryList.removeEventListener === 'function') {
          this.mediaQueryList.removeEventListener('change', this.setHeaderHeightHandler);
        }
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);
          this.isScrolling = window.setTimeout(() => {
            this.preventReveal = false;
          }, 66);
          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      if (!this.searchModal) {
        this.searchModal = this.header.querySelector('details-modal');
      }

      if (this.searchModal && typeof this.searchModal.close === 'function') {
        this.searchModal.close(false);
      }

      const slideToggle = this.header.querySelector('[data-search-toggle]');
      if (slideToggle && slideToggle.getAttribute('aria-expanded') === 'true') {
        slideToggle.click();
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
